import { Box, Button, Card, CardMedia } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { Stack } from '@mui/system';
import React, { useCallback, useEffect, useState } from 'react';
import { useGetTemplateByIdQuery, useTemplatesByProductFamilyQuery, useDownloadTemplateQuery, useUploadTemplateSVGMutation } from '../features/templates/templateSlice';
import TemplateEditor from './TemplateEditor';
import DropArea from './DropArea';
import { useGetTemplateQuery, useUpdateTemplateMutation } from '../features/model/templateSlice';
import { useUploadProductImageMutation } from '../features/products/skuImageSlice';
import Loading from './Loading';

const TemplatePreview = ({template}) => {
    const { data: templateSVG, error, isLoading} = useDownloadTemplateQuery(template.svg_source, {skip: !template})
    if (isLoading) {
      return <div>Loading...</div>;
    }
    if (error) {
      return <div>Error: {error.error}</div>
    }
    if (template === null) {
      return <div></div>
    }
    const imagedata = "data:image/svg+xml;utf8,"+encodeURIComponent(templateSVG)
    return <img src={imagedata} width="400" alt="" />
}

const TemplateSelectorControl = ({sku, template, skuimage, productFamilyId, side, onChange = null}) => {
  //const { data: template, error: templateError, isLoading: templateIsLoading } = useGetTemplateQuery({template_id: templateId}, {skip: templateId === null})
  const [ currentTemplate, setCurrentTemplate ] = useState(template);
  const { data: templates, error, isLoading } = useTemplatesByProductFamilyQuery({product_family_id: productFamilyId, side: side})
  const [ uploadTemplateSVG ] = useUploadTemplateSVGMutation();

  const uploadTemplate = useCallback((files) => {
    let file = files[0];
    const reader = new FileReader()
    reader.onload = () => {
      const binaryStr = reader.result
      uploadTemplateSVG({sku_id: sku.id, side: side, data: binaryStr});
    }
    reader.readAsBinaryString(file)
  });

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error: {error}</div>
  }
  if (!templates.objects.length && currentTemplate === null) {
    return <Card>This product family does not have a {side} template</Card>
  }
  const options = templates.objects.map((tmp) => {
    return {
      id: tmp.id,
      label: tmp.name
    };
  });


  return (
    <div>
      <Stack direction="row" key={side + "template_selector"} spacing={1} textAlign="left">
        <Autocomplete
          disablePortal
          id="template-autocomplete"
          options={options}
          sx={{ width: 300 }}
          renderInput={(params) => <TextField {...params} label={currentTemplate == null ? "No Template" : currentTemplate.name}/>}
          onChange={ (event, newValue) => {
            if (onChange) {
              onChange({...newValue, side: side});
            }
          }}
        />
        <DropArea fileHandler={uploadTemplate}/>
        { template ? <Button variant="outlined" onClick={() => {onChange({id: null, side: side})}}><DeleteIcon /></Button>: <></>}
      </Stack>
      { template ? <TemplateEditor sku={sku} skuimage={skuimage} template={currentTemplate} side={side}/> : <div></div> }
      
    </div>
  )
}

const TemplateSelectionControl = ({sku, templateId, skuimage, productFamilyId, side, onChange = null}) => {
  const { data: template, error, isLoading } = useGetTemplateQuery(templateId, {skip: !templateId})
  if (productFamilyId == null) {
    return (
      <Card>No Product Family</Card>
    )
  }
  if(isLoading) {
    return <Loading />
  }
  if(error) {
    return <div>{error.error}</div>
  }
  if (!sku) return <></>;
  return <TemplateSelectorControl sku={sku} template={template} skuimage={skuimage} productFamilyId={productFamilyId} side={side} onChange={onChange}/>
}

export default TemplateSelectionControl;
